import {SET_SELECTED_GROUP} from 'constants/action-types.js';
import {SET_SELECTED_STEP} from 'constants/action-types.js';
import {SET_HOVERED_STEP} from 'constants/action-types.js';
import {SET_SELECTED_TRACK} from 'constants/action-types.js';
import {SET_EFFECTS_PANE_OPTION} from 'constants/action-types.js';
import {SET_SELECTED_PARAMETER} from 'constants/action-types.js';
import {SET_SELECTED_PARAMETER_FLASHING} from 'constants/action-types.js';
import {SET_IS_PLAYING_MIX} from 'constants/action-types.js';
import {SET_IS_RECORDING_MIX} from 'constants/action-types.js';
import {SET_MIXES} from 'constants/action-types.js';
import {SET_CURRENT_MIX} from 'constants/action-types.js';
import {SET_ERASING_AUTOMATION} from 'constants/action-types.js';
import {SET_MULTI_PARAMETER_SLIDER} from 'constants/action-types.js';
import {SET_MIX_VIEW_MODE} from 'constants/action-types.js';
import {SET_SUB_SEQUENCE_FADE} from 'constants/action-types.js';
import {SET_SUB_SEQUENCE_MUTED} from 'constants/action-types.js';
import {SET_SELECTED_SEQUENCE} from 'constants/action-types.js';
import {SET_GROUP_COLLAPSED} from 'constants/action-types.js';
import {SET_SELECTED_MIX_EFFECT} from 'constants/action-types.js';
import {SET_MIX_TRACK_DRAGGING} from 'constants/action-types.js';
import {SET_TRACKER_PARAMETER_TO_EDIT} from 'constants/action-types.js';
import {SET_HIDE_MIXER} from 'constants/action-types.js';
import {EFFECTS, LFOS, MIXES, SUBSEQUENCE} from 'components/mix/constants.js';
import {AUDIO_FX, MIDI_FX} from 'constants/effect-types.js';

var initialState = {
    selectedTrackEffects: {},
    selectedGroupEffects: {},
    selectedTrackMidiEffects: {},
    groupCollapsed: {},
    hideMixer: true,
    selectedGroup: undefined,
    selectedTrack: undefined,
    selectedStep: undefined,
    hoveredStep: undefined,
    selectedParameter: undefined,
    selectedParameterFlashing: undefined,
    effectsPaneOption: EFFECTS,
    isPlayingMix: false,
    isRecordingMix: false,
    erasingAutomation: false,
    mixes: [],
    currentMix: undefined,
    multiParameterSliderValues: {},
    mixViewMode: SUBSEQUENCE,
    subSequenceFades: {},
    subSequenceMuted: {},
    selectedSequence: undefined,
    trackerParameterToEdit: undefined,
};

const mixReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_SELECTED_GROUP:
        return {...state, selectedGroup: action.payload};;
    case SET_SELECTED_TRACK:
        return {...state, selectedTrack: action.payload};
    case SET_TRACKER_PARAMETER_TO_EDIT:
        return {...state, trackerParameterToEdit: action.payload};
    case SET_SELECTED_STEP:
        return {...state, selectedStep: action.payload};
    case SET_HOVERED_STEP:
        return {...state, hoveredStep: action.payload};
    case SET_SELECTED_PARAMETER:
        return {...state, selectedParameter: action.payload};
    case SET_SELECTED_PARAMETER_FLASHING:
        return {...state, selectedParameterFlashing: action.payload};
    case SET_EFFECTS_PANE_OPTION:
        return {...state, effectsPaneOption: action.payload};
    case SET_HIDE_MIXER:
        return {... state, hideMixer: action.payload};
    case SET_IS_RECORDING_MIX:
        return {...state, isRecordingMix: action.payload};
    case SET_IS_PLAYING_MIX:
        return {...state, isPlayingMix: action.payload};
    case SET_MIXES:
        return {...state, mixes: action.payload};
    case SET_CURRENT_MIX:
        return {...state, currentMix: action.payload};
    case SET_ERASING_AUTOMATION:
        return {...state, erasingAutomation: action.payload};
    case SET_MIX_VIEW_MODE:
        return {...state, mixViewMode: action.payload};
    case SET_SUB_SEQUENCE_FADE:
        let fades = {... state.subSequenceFades};
        fades[action.payload.subSequenceId] = action.payload.value;
        return {...state, subSequenceFades: fades};
    case SET_MULTI_PARAMETER_SLIDER:
        let values = state.multiParameterSliderValues;
        values[action.payload.id] = action.payload.value;
        return {... state, multiParameterSliderValues: values };
    case SET_SUB_SEQUENCE_MUTED:
        let newState = {... state};
        newState.subSequenceMuted[action.payload.id] = action.payload.muted;
        return newState;
    case SET_GROUP_COLLAPSED:
        let groupCollapsed = state.groupCollapsed[action.payload.subSequenceId] || {};
        groupCollapsed[action.payload.groupNumber] = action.payload.collapsed;
        newState = {... state};
        newState.groupCollapsed[action.payload.subSequenceId] = groupCollapsed;
        return newState;
    case SET_SELECTED_SEQUENCE:
        return {
            ... state,
            selectedSequence: action.payload
        };
    case SET_SELECTED_MIX_EFFECT:
        let {subSequenceId, effectType, trackNumber, groupNumber, effect} = action.payload;

        if (action.payload.effectType === AUDIO_FX) {
            // audio fx
            if (action.payload.trackNumber !== undefined) {
                // track
                let subSequenceFX = {... state.selectedTrackEffects[subSequenceId]};
                subSequenceFX[trackNumber] = effect;
                let selectedTrackEffects = {... state.selectedTrackEffects};
                selectedTrackEffects[subSequenceId] = subSequenceFX;
                return {
                    ... state,
                    selectedTrackEffects
                };
            } {
                // group
                let subSequenceFX = {... state.selectedGroupEffects[subSequenceId]};
                subSequenceFX[groupNumber] = effect;
                let selectedGroupEffects = {... state.selectedGroupEffects};
                selectedGroupEffects[subSequenceId] = subSequenceFX;
                return {
                    ... state,
                    selectedGroupEffects
                };
            }
        } else {
            // midi fx
            let subSequenceFX = {... state.selectedTrackMidiEffects[subSequenceId]};
            subSequenceFX[trackNumber] = effect;
            let selectedTrackMidiEffects = {... state.selectedTrackMidiEffects};
                selectedTrackMidiEffects[subSequenceId] = subSequenceFX;
                return {
                    ... state,
                    selectedTrackMidiEffects
                };
        }
    case SET_MIX_TRACK_DRAGGING:
        return {
            ... state,
            trackDragging: action.payload
        };
    default:
        return state;
    }
};
export default mixReducer;
